import React from 'react';
import RcCheckbox from 'rc-checkbox';
import { RadioProps } from './types';
import './index.less';

const Radio = ({ onClick, className = '', size, ...rest }: RadioProps) => {
  return (
    <span className={`radio-wrap ${className}`} onClick={onClick}>
      <RcCheckbox prefixCls="LdsRadio" type="radio" {...rest} />
    </span>
  );
};

export default Radio;
